import ProductCard from 'gatsby-theme-husky/src/common/ProductCard/ProductCard';

import './ProductCardOverride.scss';

export default ProductCard;
